import { render } from "./SettingsMenu.vue?vue&type=template&id=35cd70b2"
import script from "./SettingsMenu.vue?vue&type=script&lang=js"
export * from "./SettingsMenu.vue?vue&type=script&lang=js"
script.render = render

export default script